$(function () {
  var $campaign = $('#gifts-campaign-multi');
  if (!$campaign.length) return;

  function generarDatoAleatorioGift() {
    var letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var numeros = '0123456789';
    var resultado = '';

    for (var i = 0; i < 2; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }

    for (var j = 0; j < 3; j++) {
      resultado += numeros.charAt(Math.floor(Math.random() * numeros.length));
    }

    return resultado.split('').sort(function () {
      return 0.5 - Math.random();
    }).join('');
  }

  function initGiftSliders() {
    $('#gifts-campaign-multi [data-gift-slider]').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        $slider.addClass('is-slider-ready');
        return;
      }

      $slider.on('init', function () {
        $slider.addClass('is-slider-ready');
      });

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true
            }
          }
        ]
      });
    });
  }

  function updateGiftGroups() {
    $('#gifts-campaign-multi .campaign-gift-group').each(function () {
      var $group = $(this);
      var required = parseInt($group.attr('data-required'), 10) || 1;
      var selected = $group.find('input:checked').length;

      $group.find('[data-selected-count]').text(selected);
      $group.find('[data-required-count]').text(required);

      if (selected >= required) {
        $group.addClass('is-complete');
      } else {
        $group.removeClass('is-complete');
      }

      var $checkboxes = $group.find('input[type="checkbox"]');

      if ($checkboxes.length) {
        if (selected >= required) {
          $checkboxes.not(':checked').prop('disabled', true);
        } else {
          $checkboxes.not('.is-originally-disabled').prop('disabled', false);
        }
      }
    });
  }

  function validateGiftGroups() {
    var isValid = true;
    var missingMessages = [];

    $('#gifts-campaign-multi .campaign-gift-group').each(function () {
      var $group = $(this);
      var groupName = $group.attr('data-gift-group');
      var required = parseInt($group.attr('data-required'), 10) || 1;
      var selected = $group.find('input:checked').length;

      if (selected !== required) {
        isValid = false;

        if (groupName === '10ml') {
          missingMessages.push('Please select your complimentary 10ml bottle.');
        } else if (required === 2) {
          missingMessages.push('Please select your two complimentary samples.');
        } else if (required === 3) {
          missingMessages.push('Please select your three complimentary samples.');
        } else {
          missingMessages.push('Please select your complimentary sample.');
        }
      }
    });

    if (!isValid) {
      $('#gifts-campaign-multi .message-fails p.gift-message')
        .html(missingMessages.join('<br>'))
        .show();
    } else {
      $('#gifts-campaign-multi .message-fails p').hide();
    }

    return isValid;
  }

  function moveSliderToSelected($input) {
    var $slider = $input.closest('[data-gift-slider]');

    if (!$slider.hasClass('slick-initialized')) return;

    var slideIndex = parseInt($input.closest('.slick-slide').attr('data-slick-index'), 10);

    if (!isNaN(slideIndex)) {
      $slider.slick('slickGoTo', slideIndex);
    }
  }

  $('#gifts-campaign-multi input:disabled').addClass('is-originally-disabled');

  $(document).on('change', '#gifts-campaign-multi input', function () {
    var $input = $(this);

    $('#gifts-campaign-multi .message-fails p').hide();

    if ($input.attr('type') === 'radio' && $input.is(':checked')) {
      moveSliderToSelected($input);
    }

    updateGiftGroups();
  });

  $('#gifts-campaign-multi__button').on('click', function () {
    if (!validateGiftGroups()) return;

    var $button = $(this);
    var variantId = $('.product-form select[name="id"]').val();
    var bottleSet = $campaign.attr('data-bottle-set') || 'Bottle';
    var randomSetId = generarDatoAleatorioGift();

    var shippingNote = $campaign.attr('data-shipping-note') || '';

    function buildProps(props) {
      if (shippingNote) {
        props['Shipping'] = shippingNote;
      }
      return props;
    }

    // EXPECTED SHIP DATE: solo en el producto principal, si tiene el metacampo
    // custom.expected_ship_date (input oculto del snippet expected-ship-date)
    var expectedShipDate = $('form.form input[data-expected-ship-date]').val() || '';

    var productosData = [];

    var mainProps = buildProps({
      'SET': bottleSet,
      'ID SET': randomSetId
    });

    if (expectedShipDate) {
      mainProps['Expected Ship Date'] = expectedShipDate;
    }

    productosData.push({
      id: variantId,
      quantity: 1,
      properties: mainProps
    });

    var gwpAvailable = $campaign.attr('data-gwp-available') === 'true';
    var gwpVariantId = $campaign.attr('data-gwp-variant');
    if (gwpAvailable && gwpVariantId) {
      productosData.push({
        id: gwpVariantId,
        quantity: 1,
        properties: buildProps({
          'SET': 'Surprise Gift',
          'ID SET': randomSetId
        })
      });
    }

    $('#gifts-campaign-multi input:checked').each(function (index) {
      var $input = $(this);
      var giftVariantId = $input.val();
      var giftGroup = $input.attr('data-gift-group');

      var giftSetName = giftGroup === '10ml'
        ? '10ml Gift Bottle'
        : '2ml Gift Sample';

      productosData.push({
        id: giftVariantId,
        quantity: 1,
        properties: buildProps({
          'SET': giftSetName,
          'ID SET': randomSetId,
          '_gift_group': giftGroup,
          '_gift_slot': String(index + 1)
        })
      });
    });

    $button.text('Adding...');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: productosData
      },
      dataType: 'json',
      success: function () {
        $button.text('Add to Cart');
        console.log('Productos al carrito');
      },
      error: function () {
        $button.text('Add to Cart');
        console.log('Error al agregar los productos al carrito');
      }
    });
  });

  initGiftSliders();
  updateGiftGroups();
});